import { createSelector } from 'reselect'
import { namespace } from '.'
import { State } from './reducer'

export const getState = (state: { [namespace]: State }) => state[namespace]

export const getBenchmarkData = createSelector(
  [getState],
  (state) => state.benchmarkInfo
)

export const getBenchmarkDataError = createSelector(
  [getState],
  (state) => state.error
)

export const getBenchmarkDataPending = createSelector(
  [getState],
  (state) => state.pending
)

const getSecuritySearchMap = createSelector(
  [getState],
  (state) => state.securitySearch
)

/* memoized on the map (not the whole slice) so the streaming benchmarkInfo
updates don't hand consumers a new closure on every price tick */
export const getSecuritySearch = createSelector(
  [getSecuritySearchMap],
  (securitySearch) => (gridIndex: number) => securitySearch[gridIndex] ?? ''
)
